// extracted by css-extract-rspack-plugin
export default {"cls1":"Comments-cls1_vtr","cls2":"Comments-cls2_G9m Comments-cls1_vtr"};